import React from 'react';
import './Navbar.css';

export default function Banner() {
  return (
    <a href="https://jamhacks.ca" style={{}} className="navbar-banner">
      Jamhacks 7 is here!
    </a>
  );
}
